export default [
  {
    path: '/disciplines',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'disciplines-list' */ '@/views/disciplines/List'),
  },
  {
    path: '/disciplines/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'disciplines-create' */ '@/views/disciplines/Create'),
  },
  {
    path: '/disciplines/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'disciplines' */ '@/views/disciplines/Discipline'),
  }
]
